import React from "react";
import { Container, Row, Col } from "shards-react";

import ProfileClientComponent from "../components/customer/ProfileClientComponent";


const UserProfileLite = () => (
  <Container fluid className="main-content-container px-4">
    <Row>
      <ProfileClientComponent />
    </Row>
  </Container>
);

export default UserProfileLite;
